/**
 * The shape of a card before there is a card.
 *
 * Held back for a beat after the ask goes out: a turn that comes back quickly should
 * never flash an empty frame on its way. Once shown, one stands in for every recipe
 * still being written, so the menu keeps its shape as the real ones arrive rather than
 * shunting the page around.
 */
export function HeroSkeleton() {
  return (
    <div className="hero skel" aria-hidden>
      <div className="skel-photo" />
      <div className="hero-body">
        <div className="skel-line" style={{ width: '30%', height: 11 }} />
        <div className="skel-line" style={{ width: '72%', height: 24, marginTop: 12 }} />
        <div className="skel-line" style={{ width: '96%', marginTop: 14 }} />
        <div className="skel-line" style={{ width: '84%' }} />
        <div className="skel-line" style={{ width: '40%', marginTop: 14 }} />
        <div className="skel-line skel-btn" />
      </div>
    </div>
  )
}

export function AltSkeleton() {
  return (
    <div className="alt skel" aria-hidden>
      <div className="skel-photo skel-thumb" />
      <div style={{ flex: 1 }}>
        <div className="skel-line" style={{ width: '62%', height: 14 }} />
        <div className="skel-line" style={{ width: '38%', height: 10, marginTop: 8 }} />
      </div>
    </div>
  )
}
